<ng-container *ngIf="surveyViewerService.activeSurvey$ | async">
  <div data-testId="propsForm">
      <div *ngFor="let statementKey of question.statementsOrder let i = index;">
          <img
                  *ngIf="surveyViewerService.getStatementLabelImageUrl(question, statementKey, activeLang) && question.useImage"
                  src="{{surveyViewerService.getStatementLabelImageUrl(question, statementKey, activeLang)}}"
                  alt="image" [style.width]="question.imageSize+'px'"
                  class="image-label">
          <mat-form-field class="props-input-container" data-testId="props">
              <mat-label>
                  {{question.statements[statementKey].label | translateLabel: activeLang}}
              </mat-label>
              <input appNoPaste [errorStateMatcher]="errorMatcher" matInput [type]="(question.useNumericalValues) ? 'number' : 'text'"
                     [formControl]="$any(questionFormControl.get(statementKey))"
                     (blur)="questionFormControl.get(statementKey).setValue($event.target.value.trim())">
              <mat-error>
                  {{'Champ obligatoire'|transloco}}.
              </mat-error>
          </mat-form-field>
      </div>
  </div>
</ng-container>
